<template>
    <div>
        <van-empty :description="description"  :image="image" />
    </div>
</template>
<script>
import emptyImg from '../assets/images/empty_img.png'
export default {
    name: 'empty',
    props: {
        description: {
            type: String,
            default: '暂无内容'
        },
        image: {
            type: String,
            default: emptyImg
        }
    }
}
</script>
<style lang="less" scoped>
.px2rem(@name,@px){
    @{name}: @px / 37.5px * 1rem
}

::v-deep{
    .van-empty {
        .px2rem(padding-bottom, 40);
    }
    .van-empty__image {
        .px2rem(width,436);
        .px2rem(height,290);
    }
    .van-empty__description {
        .px2rem(margin-top,48);
        .px2rem(font-size,28);
        color: #666;
    }
}
</style>